const appConfig = {
    // apiPrefix: '/api',
    apiPrefix: process.env.REACT_APP_BACKEND_API,
    // apiPrefix: 'http://localhost:5004',
    authenticatedEntryPath: '/home',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    locale: 'en',
    enableMock: false,
}

export default appConfig
